import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetUserReportsCB} from "../../ope/report/GetUserReportsCB";
import {PutUserReportCB} from "../../ope/report/PutUserReportCB";
import {DelUserReportCB} from "../../ope/report/DelUserReportCB";
import {ExecUserReportCB} from "../../ope/report/ExecUserReportCB";

@Injectable({
  providedIn: 'root'
})
export class UserReportOpeService extends BaseOPEService {

  public getUserReports(cb: GetUserReportsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putUserReport(cb: PutUserReportCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delUserReport(cb: DelUserReportCB): Promise<any> {
    return this.execOPE(cb);
  }

  public execUserReport(cb: ExecUserReportCB): Promise<any> {
    return this.execOPE(cb);
  }

}
